import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import FilterItemImpl from './filter-item';
import { noop } from 'mojito/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * FilterBar internal view component representing an individual filter item.
 *
 * @class FilterItem
 * @memberof Mojito.Modules.FiltersBar
 */

/**
 * FilterItem prop types.
 *
 * @property {object} item - The filter item content.
 * @property {object} refs - The references object for the filter items.
 * @property {boolean} [isSelected] - Flag indicating if the filter item is selected.
 * @property {Function} [onFilterClicked = () => {}] - A callback triggered when a filter item is clicked. It receives the filter 'id' as a parameter.
 * @property {Function} [getItemHrefLink = () => {}] - Callback function to obtain the hrefLink property for SEO purposes.
 *
 * @memberof Mojito.Modules.FiltersBar.FilterItem
 */

const propTypes = {
    item: PropTypes.object.isRequired,
    refs: PropTypes.object.isRequired,
    isSelected: PropTypes.bool,
    onFilterClicked: PropTypes.func,
    getItemHrefLink: PropTypes.func,
};

const defaultProps = {
    isSelected: false,
    onFilterClicked: noop,
    getItemHrefLink: noop,
};

export default UIView('FilterItem', FilterItemImpl, propTypes, defaultProps);
